import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CoursesService } from 'projects/shared/src/services/Courses.service';
import { PathologyAnatomyService } from 'projects/shared/src/services/pathology-anatomy.service';
import { SwalService } from 'projects/shared/src/services/swal.service';
import { environment } from 'public/environments/environment';


export interface DialogData {
  moduleLessonId: number;
  isExam: boolean;
}

@Component({
  selector: 'app-exam-confirmation',
  templateUrl: './exam-confirmation.component.html',
  standalone: false
})
export class ExamConfirmationComponent implements OnInit, OnDestroy {
  loading = false;
  isSubmitted = false;
  counter = 0;
  sessionExamTime = environment.sessionExamTime;
  startTime = false;
  @ViewChild('counterEle') counterEle: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<ExamConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private service: CoursesService,
    private swalService: SwalService,
    private translate: TranslateService,
    private pathologyAnatomyService: PathologyAnatomyService
  ) { }

  ngOnInit(): void {
    this.speakText(this.translate.instant('exam.theExamWillEndIn'), true);
    if (this.data.moduleLessonId) {
      this.assessmentExitLog();
    }
  }

  timeDone() {
    this.dialogRef.close(true);
  }

  speakText(text, event = false): void {
    if (!('speechSynthesis' in window)) {
      alert('Your browser does not support speech synthesis.');
      return;
    }

    let utterance = new SpeechSynthesisUtterance(text);
    utterance.volume = 1; // From 0 to 1
    utterance.rate = event ? 1 : 2; // From 0.1 to 10
    utterance.pitch = 1; // From 0 to 2
    // utterance.text = text;
    utterance.lang = localStorage.getItem('language') === 'ar' ? 'ar-SA' : 'en-US';

    // Speak the text
    window.speechSynthesis.speak(utterance);
    if (!this.startTime && event) {
      utterance.onend = () => {
        this.startTime = true;
        this.counterEle.nativeElement.click();
      };

    }
  }

  assessmentExitLog() {
    this.loading = true;
    let serviceTarget = this.service.assessmentExitLog(this.data.moduleLessonId);
    if (this.data.isExam) {
      serviceTarget = this.pathologyAnatomyService.assessmentExitLog(this.data.moduleLessonId);
    }
    serviceTarget.subscribe(res => {
      this.loading = false;
      if (res) {
        // if (res.isValid) {
        //   this.swalService.swalSuccess('Message send');
        // } else {
        //   this.swalService.swalFailed('Invalid Mobile number!');
        // }
      }
    }, error => {
      this.loading = false;
      this.swalService.swalFailed(error.title);
    });
  }

  ngOnDestroy(): void {
    // if (('speechSynthesis' in window)) {
    //   // window.speechSynthesis.cancel();
    //   console.log(window.speechSynthesis)
    // }
  }

}
